import archive1 from '../assets/archive1.png';
import archive2 from '../assets/archive2.jpg';
import archive3 from '../assets/archive3.png';
import archive7 from '../assets/430x300.png';

export const ArchiveData: any = [
  {
    image: archive7,
    title: 'Srpski dani osiguranja 2023.',
    text: 'Svi ključni pokazatelji poslovanja sektora osiguranja u proteklih deset godina beleže pozitivan trend i više su nego udvostručeni, izjavila je guverner Narodne banke Srbije Jorgovanka Tabaković. Ona je na Zlatiboru, otvarajući sedme „Srpske dane osiguranja“ dodala da je premija osiguranja po stanovniku u prethodnoj deceniji povećana sa 79 na 171 evro, a da ukupna premija beleži rast sa 64 milijarde dinara u 2013. godini na 133,9 milijarde dinara u 2022. godini. I iznos rešenih šteta je više nego dupliran u prethodnih deset godina – sa 28,7 na 68,9 milijardi dinara.',
    imageArray: [],
    id: 1,
    link: 'https://uos.rs/2023/12/01/odrzani-sedmi-srpski-dani-osiguranja-trziste-stabilno-cir/'
  },
  {
    image: archive2,
    title: 'Srpski dani osiguranja 2022.',
    text: 'U organizaciji Udruženja osiguravača Srbije održani su 6. Srpski dani osiguranja, pod motom "Nije sve u svoje vreme, već sve u tvoje vreme". Konferencija je i ove godine okupila vodeće ljude struke iz Srbije i regiona, predstavnike regulatornog tela...',
    imageArray: [],
    id: 1,
    link: 'https://uos.rs/sdo-2022-srpski-dani-osiguranja-cir/'
  },
  {
    image: archive1,
    title: 'Srpski dani osiguranja 2021.',
    text: 'U organizaciji Udruženja osiguravača Srbije održani su 5. Srpski dani osiguranja, pod motom "Tempora mutantur - vremena se menjaju". Konferencija je i ove godine okupila vodeće ljude struke iz Srbije i regiona, predstavnike regulatornog tela...',
    imageArray: [],
    id: 2,
    link: 'https://uos.rs/sdo-2021-5-srpski-dani-osiguranja-cir/'
  },
  {
    image: archive3,
    title: 'Srpski dani osiguranja 2020.',
    text: 'U organizaciji Udruženja osiguravača Srbije održani su 4. Srpski dani osiguranja.',
    imageArray: [],
    id: 3,
    link: 'https://uos.rs/%d1%81%d1%80%d0%bf%d1%81%d0%ba%d0%b8-%d0%b4%d0%b0%d0%bd%d0%b8-%d0%be%d1%81%d0%b8%d0%b3%d1%83%d1%80%d0%b0%d1%9a%d0%b0-2020/'
  },
  {
    image: archive3,
    title: 'Srpski dani osiguranja 2019.',
    text: 'U organizaciji Udruženja osiguravača Srbije održani su 3. Srpski dani osiguranja.',
    imageArray: [],
    id: 4,
    link: 'https://uos.rs/%d1%81%d1%80%d0%bf%d1%81%d0%ba%d0%b8-%d0%b4%d0%b0%d0%bd%d0%b8-%d0%be%d1%81%d0%b8%d0%b3%d1%83%d1%80%d0%b0%d1%9a%d0%b0-2019/'
  },
  {
    image: archive3,
    title: 'Srpski dani osiguranja 2018.',
    text: 'U hotelu "Izvor" u Aranđelovcu, od 28-30. novembra 2018. godine održani su Drugi "Srpski dani osiguranja" u organizaciji udruženja osiguravača Srbije. Konferencija je okupila oko 300 stručnjaka iz zemlje i inostranstva, koji su, kroz dva okruga..."',
    imageArray: [],
    id: 5,
    link: 'https://uos.rs/%d1%81%d1%80%d0%bf%d1%81%d0%ba%d0%b8-%d0%b4%d0%b0%d0%bd%d0%b8-%d0%be%d1%81%d0%b8%d0%b3%d1%83%d1%80%d0%b0%d1%9a%d0%b0-2018/'
  },
  {
    image: archive3,
    title: 'Srpski dani osiguranja 2017.',
    text: 'Udruženje osiguravača Srbije organizovalo je od 28.-30. novembra 2017. godine konferenciju “Srpski dani osiguranja” koja je okupila oko 200 domaćih i stručnjaka iz inostranstva iz oblasti osiguranja i reosiguranja, predstavnika regulatornih tela...',
    imageArray: [],
    id: 6,
    link: 'https://uos.rs/%D1%81%D1%80%D0%BF%D1%81%D0%BA%D0%B8-%D0%B4%D0%B0%D0%BD%D0%B8-%D0%BE%D1%81%D0%B8%D0%B3%D1%83%D1%80%D0%B0%D1%9A%D0%B0-2017/'
  }
];
